export const PloshchadkaMessages = {
  plschdka: {
    display_name: "Имя",
  },
}